import { render, staticRenderFns } from "./hotProductList.vue?vue&type=template&id=2b9e6584"
import script from "./hotProductList.vue?vue&type=script&lang=js"
export * from "./hotProductList.vue?vue&type=script&lang=js"
import style0 from "./hotProductList.vue?vue&type=style&index=0&id=2b9e6584&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports